import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function generate_report_Action(token, organisationId, groupId, tagId) {
    
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/generate/organisation/group/${groupId}/report/${tagId}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
                organisationId: organisationId,
                },
            // body:"",
            types: [
                types.GENERATE_REPORT_REQUEST,
                types.GENERATE_REPORT_RECEIVE, {
                    type: types.GENERATE_REPORT_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const reset_generate_report_Action = () => {
    return {
        type: types.RESET_GENERATE_REPORT,
        payload: null
    }
};
